import React, {} from 'react';
const styles = {"wordmark":"Wordmark-module__wordmark__Y71I9"};
/** trynaru.com's "naru." wordmark: the name lowercased in the display font, then an orange dot. */
export function Wordmark({ label, href }) {
    return (React.createElement("a", { className: styles.wordmark, href: href }, label));
}
//# sourceMappingURL=Wordmark.js.map